export function nameof<TObject>(obj: TObject, key: keyof TObject): string;
export function nameof<TObject>(key: keyof TObject): string;
export function nameof(key1: any, key2?: any): any {
  //console.log('nameof', { key1, key2 });
  return key2 ?? key1;
}
